import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useGlobalModalStore } from '@/stores/useGlobalModalStore/useGlobalModalStore'
import { DeleteReportContent } from '@/components/molecules/DeleteReportContent/DeleteReportContent'
import { ReportType } from '@/hooks'

type UseDeleteReportProps = {
    reportId: string
    reportName: string
    type?: ReportType
}

export const useDeleteReport = ({
    reportId,
    reportName,
    type,
}: UseDeleteReportProps) => {
    const { t } = useTranslation('translations')
    const setModalState = useGlobalModalStore((state) => state.setModalState)

    const closeModal = useCallback(() => {
        setModalState({ isOpen: false })
    }, [setModalState])

    const openDeleteReportModal = useCallback(() => {
        setModalState({
            isOpen: true,
            title: t('reporting.delete_report.title'),
            icon: 'warning',
            description: t('reporting.delete_report.description', {
                reportName,
            }),
            content: () => (
                <DeleteReportContent
                    reportId={reportId}
                    reportName={reportName}
                    type={type}
                />
            ),
            onClose: closeModal,
        })
    }, [setModalState, t, reportName, closeModal, reportId, type])

    return {
        openDeleteReportModal,
        closeDeleteReportModal: closeModal,
    }
}
